export const SET_IS_COLLAPSED = 'CONTEXTUAL_SIDEBAR.IS_COLLAPSED';

export const setIsCollapsed = isCollapsed => ({
  type: SET_IS_COLLAPSED,
  isCollapsed,
});
